import React from 'react';
import { useTranslation } from '../../i18n';

export function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="no-print w-full border-t border-gray-200 bg-white py-6 mt-auto dark:border-[#33334d] dark:bg-[#16162a]">
      <div className="mx-auto max-w-6xl px-4 text-center text-sm text-gray-500 dark:text-gray-400">
        <p>{t('footer.copyright')}</p>
      </div>
    </footer>
  );
}
